import React from 'react'
import {ResetPasswordComponent} from 'hec/components/reset-password/reset-password'
export const ResetPasswordBuilder: React.FC = () => {
    return <ResetPasswordComponent />
}

export const ResetPasswordDefinition = {
    component: ResetPasswordBuilder,
    name: 'ResetPassword',
    noWrap: true,
    inputs: []
}
